import classNames from 'classnames';
import type { FC } from 'react';
import type { ConversationMessagePart } from 'types/ai.types';
import AIMessagePartConsent from './AIMessagePartConsent';
import AIMessagePartText from './AIMessagePartText';
import AIMessagePartThinking from './AIMessagePartThinking';
import AIMessagePartTool from './AIMessagePartTool';
import AIMessagePartPlaceholder from './AIMessagePartPlaceholder';

const AIMessagePart = (props: {
  messagePart: ConversationMessagePart;
  messageId: string;
  isSmall?: boolean;
  messageParts: ConversationMessagePart[];
  isLastPart?: boolean;
}) => {
  const { messagePart } = props;

  switch (messagePart.type) {
    case 'text':
      return <AIMessagePartText {...props} messagePart={messagePart} />;
    case 'thinking':
      return <AIMessagePartThinking {...props} messagePart={messagePart} />;
    case 'tool':
      return <AIMessagePartTool {...props} messagePart={messagePart} />;
    case 'consent_text':
      return <AIMessagePartConsent {...props} messagePart={messagePart} />;
    default:
      return null;
  }
};

type AIMessagePartsProps = {
  messageParts: ConversationMessagePart[];
  messageId: string;
  isSmall?: boolean;
};

const AIMessageParts: FC<AIMessagePartsProps> = ({
  messageParts,
  messageId,
  isSmall,
}) => {
  return (
    <div
      className={classNames('flex-1 flex flex-col gap-4 px-1', {
        'py-2': !isSmall,
      })}
    >
      {messageParts.length ? (
        messageParts.map((part, index) => (
          <AIMessagePart
            key={`${messageId}-${part.type}-${index}`}
            messagePart={part}
            messageId={messageId}
            messageParts={messageParts}
            isSmall={isSmall}
            isLastPart={index === messageParts.length - 1}
          />
        ))
      ) : (
        <AIMessagePartPlaceholder messageId={messageId} isSmall={isSmall} />
      )}
    </div>
  );
};

export default AIMessageParts;
